export * from './coupon-details.page'